export enum ProductType {
	ATTRACTION_PARK = 'ATTRACTION_PARK',
	CULTURAL = 'CULTURAL',
	PLAY_SPORT_ADVENTURE = 'PLAY_SPORT_ADVENTURE',
	ANIMAL_PARK = 'ANIMAL_PARK',
	NATURE_PARK = 'NATURE_PARK',
	WATER = 'WATER',

	CAMPING = 'CAMPING',
	YOUTH_ACCOMMODATION = 'YOUTH_ACCOMMODATION',
	HOLIDAY_COTTAGE = 'HOLIDAY_COTTAGE',
	GENERIC_TERRAIN = 'GENERIC_TERRAIN',
	HOSTEL = 'HOSTEL',
	GENERIC_ROOMS = 'GENERIC_ROOMS',
	HOLIDAY_PARK = 'HOLIDAY_PARK',
	HOTEL = 'HOTEL',
	BED_AND_BREAKFAST = 'BED_AND_BREAKFAST',
}

export const PRODUCT_TYPES_DAYTRIP = [
	ProductType.ATTRACTION_PARK,
	ProductType.CULTURAL,
	ProductType.PLAY_SPORT_ADVENTURE,
	ProductType.ANIMAL_PARK,
	ProductType.NATURE_PARK,
	ProductType.WATER,
];

export const PRODUCT_TYPES_ACCOMMODATION = [
	ProductType.BED_AND_BREAKFAST,
	ProductType.CAMPING,
	ProductType.GENERIC_TERRAIN,
	ProductType.HOTEL,
	ProductType.GENERIC_ROOMS,
	ProductType.HOSTEL,
	ProductType.YOUTH_ACCOMMODATION,
	ProductType.HOLIDAY_PARK,
	ProductType.HOLIDAY_COTTAGE,
];

export const PRODUCT_TYPES_ACCOMMODATION_FOR_FILTERS = [
	ProductType.BED_AND_BREAKFAST,
	'CAMPING_AND_TERRAIN',
	// ProductType.CAMPING,
	// ProductType.GENERIC_TERRAIN,
	'HOTEL_AND_ROOMS',
	// ProductType.HOTEL,
	// ProductType.GENERIC_ROOMS,
	ProductType.HOSTEL,
	ProductType.YOUTH_ACCOMMODATION,
	ProductType.HOLIDAY_PARK,
	ProductType.HOLIDAY_COTTAGE,
];
